import { request } from './core.api';
import type { DamageReportDto } from './damage-reports.api';

export interface TenantPortalPropertyDto {
  rentalAgreementId: string;
  propertyId: string;
  propertyAddress: string;
  propertyStatus: string;
  landlordDisplayName: string;
  relationshipType: 'candidate' | 'active' | 'future' | 'past';
  agreementStatus: string;
  interestDate?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  rentAmount?: number | null;
  welcomePageUrl?: string | null;
  damageReports: DamageReportDto[];
}

export interface TenantPortalOverviewDto {
  candidateProperties: TenantPortalPropertyDto[];
  activeProperties: TenantPortalPropertyDto[];
  futureProperties: TenantPortalPropertyDto[];
  pastProperties: TenantPortalPropertyDto[];
}

export type TenantPortalSection = 'applications' | 'active' | 'upcoming' | 'history';

export function getTenantPortalSectionItems(
  overview: TenantPortalOverviewDto,
  section: TenantPortalSection,
): TenantPortalPropertyDto[] {
  switch (section) {
    case 'applications':
      return overview.candidateProperties;
    case 'active':
      return overview.activeProperties;
    case 'upcoming':
      return overview.futureProperties;
    case 'history':
      return overview.pastProperties;
    default:
      return [];
  }
}

export const tenantPortalApi = {
  getOverview: () => request<TenantPortalOverviewDto>('/tenant-portal/overview'),
};
